//Labeeb
// const BASE_URL = "http://192.168.9.7:5005/node_api/";

//Demo
// const BASE_URL = "http://162.19.146.134:1788/node_api/";

//Live
const BASE_URL = "https://admin.addsuccess.in/node_api/"


const DEFAULT_KEY = process.env.REACT_APP_DEFAULT_KEY

const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;
const RAZORPAY_KEY_SECRET = process.env.REACT_APP_RAZORPAY_KEY_SECRET;


const PAYPAL_CLIENT_ID = ""

export { BASE_URL, DEFAULT_KEY, PAYPAL_CLIENT_ID, RAZORPAY_KEY_ID, RAZORPAY_KEY_SECRET }       